import { render, staticRenderFns } from "./OlOverlay.vue?vue&type=template&id=58a05774&scoped=true&"
import script from "./OlOverlay.vue?vue&type=script&lang=ts&"
export * from "./OlOverlay.vue?vue&type=script&lang=ts&"
import style0 from "./OlOverlay.vue?vue&type=style&index=0&id=58a05774&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58a05774",
  null
  
)

export default component.exports